import { find, forEach, map, filter, max } from 'lodash'

const folderName = Wiz.globalSettings.globalConfig?.modelSetting?.folderName || ''
const EnumAPBTUV = 6 // UV属性绑定
const EnumKFTTReal2 = 2 // 二维向量(double2)类型

/**
 * 批量向片段中添加轨道数据
 */
const formTracks = async (paramList, clips) => {
  const res = []
  for (let i = 0; i < paramList.length; i += 1) {
    const tempObj = {
      node: paramList[i].node,
      clip: clips[i],
      trackParam: {
        trackType: EnumKFTTReal2,
        propertyLinkType: EnumAPBTUV,
      },
    }
    res.push(tempObj)
  }
  return res
}
/**
 * @description 根据材质贴图倍数，匹配不同的时间倍数
 * @param {String} multiple 当前材质贴图倍数
 * @returns
 */
const getMoveTime = (multiple) => {
  if (multiple === '2') {
    return 1
  }
  if (multiple === '4') {
    return 2
  }
  if (multiple === '8') {
    return 3
  }
  if (multiple === '16') {
    return 4
  }
  return 5
}
/**
 * 批量向片段中添加轨道数据
 * @param {list} nodeList node数据
 */
const formKeys = async (nodeList, trackList) => {
  const res = []
  const lFlow = [
    [0, 0],
    [1, 0],
  ]
  const rFlow = [
    [1, 0],
    [0, 0],
  ]
  for (let i = 0; i < nodeList.length; i += 1) {
    const time = getMoveTime(nodeList[i].multiple)
    const tempObj1 = {
      keyframeTrack: trackList[i],
      time: 0,
    }
    const tempObj2 = {
      keyframeTrack: trackList[i],
      time: time * 5,
    }
    if (nodeList[i].direction) {
      tempObj1.value = lFlow[0]
      tempObj2.value = lFlow[1]
    } else {
      tempObj1.value = rFlow[0]
      tempObj2.value = rFlow[1]
    }
    res.push(tempObj1)
    res.push(tempObj2)
  }
  return res
}

/**
 * 批量向片段中添加轨道数据
 * @param {list} nodesList node数据
 */
const formLoops = async (actionList, loop, repetition) => {
  const res = []
  for (let i = 0; i < actionList.length; i += 1) {
    res.push({
      action: actionList[i],
      loopMode: loop,
      repetitions: repetition,
    })
  }
  return res
}

// 通过包围盒计算，匹配的贴图倍数
const getMatchMultiple = (aabb) => {
  const x = Math.abs(aabb[1][0] - aabb[0][0])
  const y = Math.abs(aabb[1][1] - aabb[0][1])
  const z = Math.abs(aabb[1][2] - aabb[0][2])
  const maxLength = max([x, y, z])
  if (maxLength <= 3) {
    return '2'
  }
  if (maxLength > 3 && maxLength <= 5) {
    return '4'
  }
  if (maxLength > 5 && maxLength <= 10) {
    return '8'
  }
  if (maxLength > 10 && maxLength <= 20) {
    return '16'
  }
  return '32'
}

const getParamsDetail = async (player, nodeInfo, nodesList, type) => {
  // 弯头需要做反向，并统一贴图尺寸
  const str = nodeInfo.direction ? 'l' : 'r'
  const strNegative = !nodeInfo.direction ? 'l' : 'r'
  const imagePath = `data://../apps/${folderName}/dynamic/pipeFlow/${nodeInfo.materialType}/2x-${nodeInfo.materialType}-${strNegative}.png`
  const childNodes = map(nodesList, 'node')
  const grandChildrenRes = await player.Native.Node.getProperty(childNodes, ['children'])
  const grandChildNodesInfo = []
  forEach(grandChildrenRes, (item) => {
    grandChildNodesInfo.push(...item.children)
  })
  let grandChildAabbs = []
  if (type === 'Pipe') {
    const grandChildNodes = map(grandChildNodesInfo, 'node')
    grandChildAabbs = await player.Native.Node.getProperty(grandChildNodes, ['aabb'])
  }
  const arr = []
  for (let i = 0; i < grandChildNodesInfo.length; i += 1) {
    let multiple = '2'
    if (type === 'Pipe') {
      // 直管线需要根据长度，来调整贴图尺寸以及动画的速度，实现整体管线流速贴图大体一致
      multiple = getMatchMultiple(grandChildAabbs[i].aabb)
    }
    arr.push({
      node: grandChildNodesInfo[i].node,
      direction: type === 'Pipe' ? nodeInfo.direction : !nodeInfo.direction,
      imgPath: `data://../apps/${folderName}/dynamic/pipeFlow/${
        nodeInfo.materialType
      }/${multiple}x-${nodeInfo.materialType}-${type === 'Pipe' ? str : strNegative}.png`,
      multiple,
    })
  }
  return arr
}
// 批量添加贴图，创建动画
const batchCreateNodesUV = async (player, paramList) => {
  // 创建带贴图材质（1）
  const materialList = await player.Native.Material.create(1, paramList.length)
  // 创建纹理
  const textureList = await player.Native.Texture.create(map(paramList, 'imgPath'))
  const nodes = map(paramList, 'node')
  const geoData = await player.Native.Node.getProperty(nodes, ['geometry'])
  const oGeoList = map(geoData, 'geometry')
  const geoList = await player.Native.PrjFunc.calcUVForGeometry(oGeoList)
  const textureParams = []
  const materialParams = []
  for (let i = 0; i < paramList.length; i += 1) {
    textureParams.push({
      material: materialList[i],
      props: {
        TEX_ALBEDO: textureList[i],
        alpha: 0.99,
      },
    })
    materialParams.push({
      node: paramList[i].node,
      props: {
        material: materialList[i],
        geometry: geoList[i],
      },
    })
  }
  await player.Native.Material.setProperty(textureParams)
  console.log('添加材质参数', materialParams)
  await player.Native.Node.setProperty(materialParams)
  console.log('node添加材质结束')
  // 添加动画
  const mixer = await player.Native.AnimationMixer.getMixer(`uv${paramList[0].node}`)
  console.log('获取混合器', mixer)
  const mixerClipList = map(paramList, (item) => {
    return {
      mixer,
      clipName: item.node,
    }
  })
  const clipsList = await player.Native.AnimationClip.getBatchClips(mixerClipList)
  console.log('动画片段', clipsList)
  const clipActionList = map(clipsList, (item) => {
    return {
      mixer,
      clip: item,
    }
  })
  const actionList = await player.Native.AnimationAction.getBatchclipActions(clipActionList)
  console.log('片段控制器', actionList)
  // 清除所有轨道
  await player.Native.KeyframeTrack.batchClearTrack(clipsList)
  const tracksParam = await formTracks(paramList, clipsList)
  const trackList = await player.Native.KeyframeTrack.batchAddTracksWithParam(tracksParam)
  console.log('添加轨道', trackList)
  // 清除轨道中关键帧
  await player.Native.KeyframeTrack.batchKeyClear(trackList)
  const trackkeysList = await formKeys(paramList, trackList)
  await player.Native.KeyframeTrack.batchKeyAppend(trackkeysList)
  const loops = await formLoops(actionList, 1, -1)
  player.Native.AnimationAction.batchSetLoop(loops)
  player.Native.AnimationAction.batchPlay(actionList)
}
// 获取uv动画及材质贴图所需参数及node
const getUVParams = async (player, nodeInfo) => {
  // 获取需要贴图的全量子节点
  const childrenRes = await player.Native.Node.getProperty([nodeInfo.node], ['children'])
  const childNodesInfo = []
  forEach(childrenRes, (item) => {
    childNodesInfo.push(...item.children)
  })
  console.log('第一层子节点', childNodesInfo)
  const pipeNodesInfo = []
  const elbowNodesInfo = []
  forEach(childNodesInfo, (item) => {
    if (item.name === 'Pipe') {
      pipeNodesInfo.push(item)
    } else if (item.name.indexOf('Degree') > -1) {
      elbowNodesInfo.push(item)
    }
  })
  let pipeGrandNodesDetail = []
  let elbowGrandNodesDetail = []
  if (pipeNodesInfo.length) {
    pipeGrandNodesDetail = await getParamsDetail(player, nodeInfo, pipeNodesInfo, 'Pipe')
    console.log('pipe数据结果', pipeGrandNodesDetail)
  }
  if (elbowNodesInfo.length) {
    elbowGrandNodesDetail = await getParamsDetail(player, nodeInfo, elbowNodesInfo, 'Elbow')
    console.log('Elbow数据结果', pipeGrandNodesDetail)
  }
  const grandChildNodesDetail = [...pipeGrandNodesDetail, ...elbowGrandNodesDetail]
  console.log('第二层管线和弯头子节点', grandChildNodesDetail)
  const grandChildNodes = map(grandChildNodesDetail, 'node')
  const materialRes = await player.Native.Node.getProperty(grandChildNodes, ['material'])
  console.log('第二层获取的材质信息', materialRes)
  const nodesWidthMaterial = map(filter(materialRes, 'material'), 'node')
  const lastNodes = filter(grandChildNodesDetail, (item) => {
    return nodesWidthMaterial.includes(item.node)
  })
  return lastNodes
}
/**
 * @description 添加流向动画
 * @param {Object} player
 * @param {Array} nodeList 需要添加贴图的父节点
 * @returns {*}
 */
const addFlowAnimation = async (player, nodeList) => {
  const newNodeList = [] // 克隆的
  let cloneNodeCol = []
  try {
    console.log('原始需要创建动画的node信息', nodeList)
    const nodeCol = map(nodeList, 'node')
    cloneNodeCol = await player.Native.Node.clone(nodeCol)
    for (let i = 0; i < nodeList.length; i += 1) {
      newNodeList.push({
        ...nodeList[i],
        node: cloneNodeCol[i],
      })
    }
    console.log('克隆需要创建动画的node信息', newNodeList)
    // 挂载参数
    const mountParameters = map(newNodeList, (item) => {
      return {
        node: item.node,
        props: {
          parent: item.parent,
          visible: true,
        },
      }
    })
    // 挂载
    await player.Native.Node.setProperty(mountParameters)
    // await player.Native.Node.addToFactory(cloneNodeCol)
    const nodeUVParams = []
    for (let j = 0; j < newNodeList.length; j += 1) {
      // eslint-disable-next-line no-await-in-loop
      nodeUVParams.push(...(await getUVParams(player, newNodeList[j])))
    }
    Promise.all(nodeUVParams)
    await batchCreateNodesUV(player, nodeUVParams)
    if (cloneNodeCol.length) {
      console.log('创建完动画后添加到工厂')
      await player.Native.Node.addToFactory(cloneNodeCol)
    }
    return map(newNodeList, (item) => {
      return {
        code: item.code,
        node: item.node,
      }
    })
  } catch (error) {
    console.error('创建流向动画失败', error)
    if (newNodeList.length) {
      const nodes = map(newNodeList, 'node')
      console.log('创建流向失败销毁复制节点')
      this.player.Native.Node.destroy(nodes)
    }
    return []
  }
}

export { batchCreateNodesUV, addFlowAnimation }
